export default {
  "website": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cestovní pojištění"])},
  "contact": {
    "tel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["+420 607 772 573"])},
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["info", "@", "travelinsurance.cz"])},
    "assistance": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["asistenční služba"])},
      "tel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["+420 296 339 631"])}
    }
  },
  "home": {
    "coverage_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cestujte bezpečně do celého světa s naším celoročním pojištěním"])},
    "what_is_covered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["rozsah pojištění"])},
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sjednat online"])},
    "price_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["roční pojistné"])},
    "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1.790 Kč"])},
    "interest_cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mám zájem"])},
    "plans": {
      "coverage_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rozsah pojištění"])},
      "select_scope": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte rozsah"])},
      "extra": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EXTRA"])},
      "plus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PLUS"])},
      "basic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["BASIC"])},
      "insured_persons_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["POČET pojištěných osob"])},
      "insured_persons_age": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["věk do 70 let"])},
      "annual_premium": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ROČNÍ pojistné"])},
      "rows": {
        "row1": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["léčebné náklady v případě úrazu a náhlého onemocnění – včetně covid"])}
        },
        "row2": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["náklady na pobyt v karanténě"])}
        },
        "row3": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["akutní zubní ošetření"])}
        },
        "row4": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["asistenční služby v zahraničí"])}
        },
        "row5": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trvalé následky úrazu / smrt úrazem"])}
        },
        "row6": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["cestovní náklady náhradníka na služební cestě"])}
        },
        "row7": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["cestovní výdaje pro rodinné příslušníky pojištěného"])}
        },
        "row8": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["zavazadla – krádež, ztráta, poškození"])}
        },
        "row9": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["právní pomoc a kauce"])}
        },
        "row10": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["opožděné dodání zavazadel při cestě letadlem"])}
        },
        "row11": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["zpoždění letu"])}
        },
        "row12": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["přerušení cesty - předčasný návrat"])}
        },
        "row13": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["náklady pátrání a horské služby – v Česku i v zahraničí"])}
        },
        "row14": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["odpovědnost za škody na věcech a na zdraví třetích osob"])}
        }
      }
    },
    "faq_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["otázky a odpovědi"])},
    "additional_services": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["doplňkové pojištení"])},
      "companions": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nahlášení spolucestujících"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nahlásit"])}
      },
      "trip_extension": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["prodloužení<br>pobytu"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["prodloužit"])}
      },
      "trip_cancel": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["storno<br>zájezdu"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["stornovat"])}
      }
    }
  },
  "test": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mám zájem o rozsah pojištění"])},
    "option_not_in_plan": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("option")), " není dostupný v rozsahu ", _interpolate(_named("plan"))])},
    "invalid": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pojištění nesplňuje Vaše požadavky"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["= prosím kontaktujte naše Klientské centrum, kde Vám poradíme vhodný produkt"])},
      "text_continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["přesně pro Vás v pracovní dny od 9:00 - 17:00"])}
    },
    "cancellation": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pojištění storna není součástí celoročního pojištění,"])},
      "title_continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["je možné ho sjednat samostatně pro jednotlivou cestu."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sjednat pojištění storna"])}
    },
    "car": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asistenční služby k motorovému vozidlu nejsou součástí celoročního pojištění, je možné je sjednat samostatně pro jednotlivou cestu."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mám zájem"])}
    },
    "bike": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asistenční služby pro cyklisty nejsou součástí celoročního pojištění, je možné je sjednat samostatně pro jednotlivou cestu."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mám zájem"])}
    }
  },
  "people": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nahlášení spolucestujících osob"])}
  },
  "application": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["údaje žádosti"])}
  },
  "order": {
    "send": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odeslat"])},
    "submitting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odesílám žádost..."])},
    "person": {
      "name": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["jméno"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jan"])}
      },
      "surname": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["příjmení"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Novák"])}
      },
      "birthday_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["datum narození"])},
      "email": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["e-mail"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["priklad", "@", "gmail.com"])}
      },
      "tel": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["telefon"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["+420 000 000 000"])}
      },
      "trip_from": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trvání cesty od"])},
      "trip_to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trvání cesty do"])}
    },
    "addPerson": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["+ přidat další osobu"])},
    "address": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["adresa trvalého pobytu"])},
      "street": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ulice"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Štefánikova"])}
      },
      "street_number": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["číslo domu"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["201"])}
      },
      "town": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["město"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Praha"])}
      },
      "zip": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PSČ"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["941 02"])}
      }
    },
    "national_id": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["rodné číslo"])},
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["napr. 2206109334"])}
    },
    "nationality": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["státní příslušnost"])},
    "id_card": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["číslo občanského průkazu"])},
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["S000002"])}
    },
    "optional": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nepovinné"])},
    "rozsah": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rozsah"])},
      "basic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["BASIC - 1 475 Kč"])},
      "plus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PLUS - 1 975 Kč"])},
      "extra": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EXTRA - 2 475 Kč"])}
    },
    "seller_code": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KOD prodejce"])},
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "action_code": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KOD prodejce"])},
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "insurance_from": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["začátek platnosti pojištění"])},
    "discount_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["slevový kód"])},
    "consent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
  },
  "datepicker": {
    "choose": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["zvolit"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["zrušit"])}
  },
  "navigation": {
    "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["zpět"])},
    "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pokračovat"])}
  },
  "gdpr": {
    "intro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Na vámi zadanou mailovou adresu Vám zasíláme potvrzení o uzavření pojištění, pojistné podmínky a veškeré informační povinnosti a prosíme Vás o jejich prostudování. Úhradou pojistného zároveň prohlašujete, že jste byli úplně, srozumitelně a v dostatečném časovém předstihu seznámeni s jejich zněním a byla Vám vysvětlena všechna ustanovení v nich obsažená.\n"])},
    "communication": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Souhlasím s elektronickou komunikací, informace související s poskytováním finančních služeb mi budou zaslány na mailovou adresu, kterou jsem zadal. Potvrzuji, že k této schránce elektronické pošty mám pravidelný přístup."])}
  },
  "payment_protection": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TODO Replace with real law checkbox"])},
  "header": {
    
  },
  "validation": {
    "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pole je povinné"])},
    "national_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rodné číslo není validní"])},
    "national_id_age": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rodné číslo není validní nebo věk je vyšší než 70 let"])},
    "zip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pole musí obsahovat 5 číslic"])},
    "tel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefonní číslo zadávejte ve formátu: +420 000 000 000"])},
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte korektní email"])}
  },
  "payment": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platba"])},
    "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platit online kartou"])},
    "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Děkujeme za provedení platby"])},
    "already_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objednávka již byla zaplacena"])},
    "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platba selhala"])},
    "ordered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Děkujeme za vytvoření objednávky. Platbu můžete provést kartou nebo převodem podle pokynů na mailu."])},
    "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokyn k platbě naleznete v emailu."])}
  },
  "files": {
    "page_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informace o rozsahu pojištění"])},
    "page_subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formuláře"])},
    "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formuláře"])},
    "law": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povinné informace"])},
    "reporting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hlášení škody"])}
  },
  "footer": {
    "all_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informace o rozsahu pojištění"])},
    "docs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formuláře"])},
    "required_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povinné informace"])},
    "withdrawal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odstoupení od smlouvy"])}
  },
  "archive": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Archiv a odstoupení od smlouvy"])}
  },
  "cookies": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Používáme cookies."])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naše webová stránka využívá pouze technicky nezbytné cookies - dočasné soubory uložené ve Vašem zařízení během jejího prohlížení. Jsou nezbytné pro správné fungování webové stránky a nepodléhají souhlasu uživatele ve smyslu nařízení GDPR. Jsou aktivní pouze během prohlížení webové stránky v okně prohlížeče a po zavření okna s webovou stránkou jsou automaticky vymazány."])},
    "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["souhlasím"])}
  },
  "companions": {
    "intro_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V ceně pojištění variant EXTRA jsou zahrnuty i spolucestující osoby v celkovém počtu maximálně 4 osoby, které prokazatelně cestují spolu s Vámi – vycestujete společně z České republiky stejným dopravním prostředkem do stejného cíle v zahraničí a společně se vrátíte zpět do vlasti."])},
    "intro_2_before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spolucestující osoby musí být předem přihlášeny do pojištění prostřednictvím této webové stránky nebo e-mailem na "])},
    "intro_2_after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" – nejméně jeden den před vycestováním z Česka - údaje v rozsahu jméno, datum narození, den začátku cesty a doba jej trvání."])},
    "intro_3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Variant pojištění BASIC a PLUS obsahují pouze pojištění pro jednu osobu - není možné do pojištění zahrnout spolucestující."])},
    "main_person": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hlavní pojištěný"])},
    "persons": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["spolucestující osoby"])}
  },
  "form": {
    "server_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technická chyba, kontaktujte prosím podporu"])},
    "not_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nenašla se platná smlouva na toto období"])},
    "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Děkujeme za vyplnění formuláře"])},
    "error_modal_ok": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])}
  },
  "cancellation": {
    "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://online.allianzsp.sk/poistenie-storno-zajazdu/?origin=10300"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poistenie storna pre jednotlivú cestu"])},
    "buttonText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dojednať online"])},
    "intro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Poistenie sa vzťahuje na náhradu nákladov za cestovné služby, ktoré nemôžte využiť kvôli zdravotným, rodinným alebo iným nepriaznivým okolnostiam - zoznam príčin je uvedený nižšie.</p><p>Krytá je aj náhrada za nevyužitú cestu - pokiaľ Váš pobyt musíte ukončiť skôr a nemáte nárok na vrátenie už zaplatených služieb = na 1 deň 5% z ceny zájazdu / max. 10 dní</p>"])},
    "also_slovak": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["aj pre pobyty na&nbsp;Slovensku"])},
    "trip_price": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["cena zájazdu"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["celková cena za cestovné náklady = doprava, ubytovanie, trajekt, vstupenky a iné dopredu uhradené služby"])},
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["suma"])}
    },
    "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["poistné"])},
    "basic": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["základný rozsah"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OCHORENIE  poisteného, spolucestujúceho alebo blízkej osoby,\n\nÚRAZ alebo SMRŤ poisteného, spolucestujúceho alebo blízkej osoby,\n\nznačná škoda na majetku - následkom živelnej udalosti alebo trestného činu\n\nzničenie / strata cestovných dokladov menej ako 3 pracovné dni pred cestou\n\npovolávací rozkaz na vojenské cvičenie doručený po uzatvorení poistenia\n\ntehotenstvo zistené po rezervácii cesty "])}
    },
    "premium": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["rozšírený rozsah"])},
      "more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NAVIAC"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["zmeškanie nástupu do dopravného prostriedku kvôli dopravnej nehode alebo poruche vlaku\nkomplikácie v mieste kam cesta smeruje - živelná udalosť, vojna, teroristický čin - po úradne vydanom odporúčaní necestovať do oblasti\nvodovodná škoda v mieste bydliska menej ako 5 dní pred cestou\n\nstrata pracovného miesta - výpoveď zo strany zamestnávateľa, nie však pre porušenie pracovnej disciplíny\npodanie žiadosti o rozvod\nneočakávané súdne predvolanie - pokiaľ súd neakceptuje cestu ako dôvod pre odloženie\nzamietnutie žiadosti o vízum, nie však kvôli neskorému podaniu alebo formálnym chybám"])}
    },
    "co-participation": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["spoluúčasť 10%"])},
      "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["10%"])}
    },
    "alert": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poistenie je potrebné dojednať do 24 hodín od zaplatenia prvej splátky alebo rezervácie cesty.\n Pri dojednaní neskôr sa uplatní čakacia lehota 14 dní od dojednania poistenia."])}
  },
  "extension": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prodloužení platnosti pojištění pro pobyt delší než 90 dní"])},
    "daysCount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["počet dní"])},
    "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["cena"])},
    "date_from": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["datum od"])},
    "date_to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["datum do"])},
    "bottomInfo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Na Vámi zadanou e-mailovou adresu Vám zasíláme potvrzení o prodloužení pojištění, které je účinné nejdříve dnem přijetí platby, proto Vás prosíme o úhradu neprodleně"])}
  }
}